export default {
  "write_description": "Write some description",
  "add_attachment": "Add attachment",
  "cant_send_empty_msg": "Can't send empty message",
  "processing_attachments_wait": "Processing of attachment files, Please wait",
  "processing": "processing",
  "already_have_profile_warning": "Do you already have an account? <br /> Log in here to link your photo and profile to the chat.",
  "email_address": "Email Address",
  "password": "Password",
  "no_connected_group_of_users": "No {{groupName}} online at the moment.",
  "send_pm": "Send Private Message",
  "invite_to_chatroom": "Invite to Chatroom",
  "report_to_admin": "Report to Admin",
  "block": "Block",
  "kick_from_my_chatrooms": "Kick From My Chatroom(s)",
  "view_profile": "View Profile",
  "leave_chat": "Leave chat",
  "select_room_to_invite": "Select room to invite",
  "no_rooms_yet": "There are no rooms available yet",
  "dismiss": "Dismiss",
  "loading": "Loading",
  "conversation_is_blocked": "This conversations is blocked",
  "conversation_blocked_by_me": "You have blocked this conversation, in order to be able to receive messages or send them please unlock.",
  "conversation_blocked_by_opponent": "You can not receive or write any new message inside this conversation unless it gets unlocked by opponent.",
  "unlock": "Unlock",
  "type_chatroom_name": "Please type name of your chatroom",
  "create_chatroom": "Create chatroom",
  "choose_chatroom_name": "Choose Chatroom's name",
  "chatroom_name_example": "example: LGBTQ FFA",
  "cancel": "Cancel",
  "create": "Create",
  "search": "Search",
  "clear": "Clear",
  "no_emoji_found": "'No Emoji Found'",
  "chose_default_skin_tone": "Choose your default skin tone",
  "search_results": "Search Results",
  "frequently_used": "Frequently Used",
  "smiles_and_ppl": "Smileys & People",
  "animals_and_nature": "Animals & Nature",
  "food_and_drink": "Food & Drink",
  "activity": "Activity",
  "travel_and_places": "Travel & Places",
  "objects": "Objects",
  "symbols": "Symbols",
  "flags": "Flags",
  "custom": "Custom",
  "default_skin_ton": "Default Skin Tone",
  "light_skin_ton": "Light Skin Tone",
  "medium_light_skin_ton": "Medium-Light Skin Tone",
  "medium_skin_ton": "Medium Skin Tone",
  "medium_dark_skin_ton": "Medium-Dark Skin Tone",
  "dark_skin_ton": "Dark Skin Tone",
  "type_your_msg_here": "Type your message",
  "too_long_text": "Avoid using long texts, they will be marked as spam!",
  "exit_chat": "Exit Chat",
  "main_logo": "Main Logo",
  "notifications": "Notifications",
  "please_wait": "Please wait",
  "no_notifications": "No notifications found",
  "you_have_been_invited": "You have been invited to {{chatroom}} Chat Room",
  "invited_by": "Invited by {{username}}",
  "close": "Close",
  "msg_cannot_be_empty": "Message cannot be empty",
  "provide_info_about_user": "Please provide more information about the user.",
  "report_details_example": "e.g. Harassment, bad behavior, AFK etc...",
  "submit": "Submit",
  "description_details": "Descriptions / Details",
  "recent_chats": "Recent Chats",
  "escorts": "escorts",
  "agencies": "agencies",
  "members": "members",
  "chatrooms": "chatrooms",
  "general_chat": "Public Chat",
  "back_to_private_area": "Back to Private Area",
  "options": "Options",
  "benelux_chat_list": "Beneluxxx.com Chat List",
  "exit": "Exit",
  "search_for_someone": "Search For Someone",
  "user_unlocked": "'User has been unlocked'",
  "server_error": "Couldn't handle the request, please try again a bit later",
  "profile_not_available_atm": "'Profile is not available at the moment'",
  "user_kicked_from_rooms": "User has been kicked out from your {{count}} chatroom(s)",
  "no_rooms_to_kick_user": "No rooms found, to kick user from",
  "user_blocked": "User has been blocked",
  "conversation_already_blocked": "Conversation was already blocked",
  "invitation_sent": "Invitation has been sent!",
  // ----------------------------------
  "sign_in": "Sign in",
  "user_disconnected": "User Disconnected",
  "welcome_to_chat": "Welcome to our chatrooms!",
  "chat_description": "Here, on the left, you will see your active conversation and on the right are other users/rooms. <br /><br /> You can either have a group chat or chat 1 on 1. Enjoy!",
  "start_chatting" : "START CHATTING",
  "duplicate_tab" : "Beneluxxx.com's Chat is in another window open. <br /> Click 'Use here', to use chat in this window",
  "use_here": 'Use Here'
}